import { ActiveColors } from '../StatusBar/StatusBar';
export const parkThresholds = [
    {
        maxPercentage: 0,
        label: 'No availability',
        color: ActiveColors.red,
    },
    {
        maxPercentage: 30,
        label: 'Nearly sold out!',
        color: ActiveColors.red,
    },
    {
        maxPercentage: 70,
        label: 'Limited availability',
        color: ActiveColors.yellow,
    },
    {
        maxPercentage: 100,
        label: 'Plenty of options',
        color: ActiveColors.green,
    },
];
export const gradeThresholds = [
    {
        maxPercentage: 0,
        label: 'No availability',
        color: ActiveColors.red,
    },
    {
        maxUnits: 5,
        percentage: 10,
        getLabel: (units) => `Only ${units} left`,
        color: ActiveColors.red,
    },
    {
        maxPercentage: 30,
        label: 'Nearly sold out',
        color: ActiveColors.red,
    },
    {
        maxPercentage: 70,
        label: 'Selling fast',
        color: ActiveColors.yellow,
    },
    {
        maxPercentage: 100,
        label: 'High availability',
        color: ActiveColors.green,
    },
];
